import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import { useGetSubscriptionPauseHistoryQuery } from "app/store/patient/api/patientApi";
import SideDrawerWrapper from "components/common/side-drawer/SideDrawerWrapper/SideDrawerWrapper";
import Loading from "components/common/loading/Loading";
import { pluralize } from "utils/string";
import PauseHistoryCard from "./PauseHistoryCard";

const useStyles = makeStyles(() => ({
  subtitle: {
    display: "flex",
    gap: "12px",
    marginTop: "4px",
    color: "#333333",
    fontSize: "12px",
    fontWeight: 400,
  },
  divider: {
    color: "#9E9E9E",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  empty: {
    color: "#757575",
    textAlign: "center",
    padding: "32px 0",
  },
}));

const PauseHistoryDrawer = ({ showDrawer, handleClose }) => {
  const classes = useStyles();
  const { patientId } = useSelector((state) => state.transmission);

  const { data, isLoading, isFetching } = useGetSubscriptionPauseHistoryQuery(
    { patientId },
    { skip: !showDrawer || !patientId, refetchOnMountOrArgChange: true }
  );

  const { pauses = [], total_pauses = 0, total_days_paused = 0 } = data || {};

  const title = (
    <div>
      <div>Subscription Pause History</div>
      <div className={classes.subtitle}>
        <span>{pluralize(total_pauses, "pause")}</span>
        <span className={classes.divider}>|</span>
        <span>{pluralize(total_days_paused, "day")} paused in total</span>
        <span className={classes.divider}>|</span>
        <span>Newest first</span>
      </div>
    </div>
  );

  const renderContent = () => {
    if (isLoading || isFetching) {
      return <Loading height="200px" />;
    }

    if (!pauses.length) {
      return (
        <p className={classes.empty}>No subscription pauses recorded yet.</p>
      );
    }

    return (
      <div className={classes.list}>
        {pauses.map((pause) => (
          <PauseHistoryCard key={pause._id} pause={pause} />
        ))}
      </div>
    );
  };

  return (
    <SideDrawerWrapper
      showDrawer={showDrawer}
      handleClose={handleClose}
      title={title}
      showFooter={false}
      style={{ width: "460px" }}
    >
      {renderContent()}
    </SideDrawerWrapper>
  );
};

export default PauseHistoryDrawer;
